<div class="wrapper">
    <div class="section ">
        <div class="container">
            <div class="row mb-4">
                <div class="col-12 col-md-12 ml-auto mr-auto text-center">
                    <h1 class="title mt-2">CONSULTA DE PREDIAL</h1>
                </div>
            </div>
            <div class="row align-items-center justify-content-center">
                <div *ngIf="!mostrar" class="col-lg-12 col-md-12">
                    <img src="/assets/img/predial/en_actualizacion.png" class="img-fluid">
                    <div class="text-center">
                        <p>¿Alguna duda? Contáctanos</p>
                        <div class="row">
                            <div class="col-md-6 col-12 borde">
                                <div class="info ">
                                    <a href="mailto:elcorreoquequieres@correo.com ">
                                        <div class="icon icon-shape icon-shape-primary icon-lg shadow rounded-circle ">
                                            <i class="ni ni-email-83 "> </i>
                                        </div>
                                    </a>
                                    <p class="description px-0 mt-2"><a
                                            href="mailto:elcorreoquequieres@correo.com ">predial@nld.gob.mx</a>
                                    </p>
                                    <span class="d-block d-sm-none borde-inferior text-center "></span>
                                    <h4 class="info-title ">Correo electrónico</h4>
                                </div>
                            </div>
                            <div class="col-md-6 col-12 ">
                                <div class="info ">
                                    <div class="icon icon-shape icon-shape-primary icon-lg shadow rounded-circle ">
                                        <i class="ni ni-mobile-button "> </i>
                                    </div>
                                    <p class="description px-0 mt-2">711-35-75 / 711-35-02</p>
                                    <h4 class="info-title ">Teléfono</h4>
                                </div>
                            </div>
                        </div>
                        <p class="mt-2">Para el mejor uso de la página te recomendamos los siguientes navegadores:
                            Chrome / Mozilla Firefox
                            / Safari</p>
                    </div>
                </div>
                <div *ngIf="mostrar"  class="col-lg- col-md-6">
                    <div class="card  shadow border-0">
                        <div class="card-body px-lg-5 py-lg-5">
                            <div class="text-center text-muted mb-4">
                                <h3>Cuenta Predial</h3>
                            </div>

                          
                           <form role="form" ngNativeValidate   autocomplete="off"   #f="ngForm" (ngSubmit)="buscar()">
                            <div class="form-group mb-3">
                                <div class="input-group input-group-alternative">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">
                                            <i class="bi bi-search"> </i>
                                        </span>
                                    </div>
                                    <input [(ngModel)]="forma.clave_catastral" name="clave_catastral" class="form-control text-dark"
                                        placeholder="Clave catastral..." numbersOnly type="text" maxlength="15" minlength="8" required />
                                </div>
                            </div>
                            <div class="text-center">
                                <small class="font-weight-bold">Solo números, No guiones, No espacios.</small>
                            </div>
                            <br>
                            <div class="text-center">
                                <p class="font-weight-bold" style="font-size:medium;"><strong>EL TOTAL YA INCLUYE <span style="color:red">EL DESCUENTO</span> AUTORIZADO.</strong></p>
                            </div>
                            <div class="text-center">
                                <p class="font-weight-bold;"><strong><span style="color:red;font-size: large;">POR DISPOSICIONES BANCARIAS Y SEGURIDAD DEL USUARIO EL PAGO ES UNICAMENTE CON TARJETAS DIGITALES VISA O MASTERCARD</span></strong></p>
                            </div>
                            <div class="text-center">
                                <button class="btn btn-primary my-4" [disabled]="!f.valid" type="submit">
                                    Consultar
                                </button>
                                <p class="text-danger font-weight-bolder mt-2" *ngIf="mensaje!=''">{{mensaje}}</p>
                            </div>
                        </form>
                        </div>
                    </div>
                    <div class="text-center">
                        <p>¿Alguna duda? Contáctanos</p>
                        <div class="row">
                            <div class="col-md-6 col-12 borde">
                                <div class="info ">
                                    <a href="mailto:elcorreoquequieres@correo.com ">
                                        <div class="icon icon-shape icon-shape-primary icon-lg shadow rounded-circle ">
                                            <i class="ni ni-email-83 "> </i>
                                        </div>
                                    </a>
                                    <p class="description px-0 mt-2"><a
                                            href="mailto:elcorreoquequieres@correo.com ">predial@nld.gob.mx</a></p>
                                    <span class="d-block d-sm-none borde-inferior text-center "></span>
                                    <h4 class="info-title ">Correo electrónico</h4>
                                </div>
                            </div>
                            <div class="col-md-6 col-12 ">
                                <div class="info ">
                                    <div class="icon icon-shape icon-shape-primary icon-lg shadow rounded-circle ">
                                        <i class="ni ni-mobile-button "> </i>
                                    </div>
                                    <p class="description px-0 mt-2">711-35-75 / 711-35-02</p>
                                    <h4 class="info-title ">Teléfono</h4>
                                </div>
                            </div>
                        </div>
                        <p class="mt-2">Para el mejor uso de la página te recomendamos los siguientes navegadores:
                            Chrome / Mozilla Firefox / Safari</p>
                    </div>
                </div>
                <!--- <div class="col-lg-5 col-md-5 ">
                    <mdb-carousel class="carousel slide carousel-fade" [animation]="'fade'">
                        <mdb-carousel-item class="mdb-item" *ngFor="let imagen of imagenes; let i = index">
                            <div class="view ">
                                <img class="img-fluid" [src]="imagen.ruta" alt="First slide" [attr.aria-label]="'Promocion predial' + i">
                                <div class="mask rgba-black-light waves-light" mdbWavesEffect></div>
                            </div>
                        </mdb-carousel-item>
                    </mdb-carousel>
                </div>-->
            </div>
        </div>
    </div>
</div>
